import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ThermostatsActions } from '../../../store/actionCreators';
import CompleteModal from '../components/CompleteModal/CompleteModal';

class CompleteModalContainer extends Component {
  closeModalSetTimeOut;
  state = {
    isClosed: this.props.isClosed
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isClosed !== this.props.isClosed && this.state.isClosed !== this.props.isClosed) {
      this.setState({ isClosed: this.props.isClosed });

      this.closeModalSetTimeOut = setTimeout(() => {
        clearTimeout(this.closeModalSetTimeOut);
        this.completeModalClose();
      }, 1000);
    }
  }

  completeModalClose = () => {
    clearTimeout(this.closeModalSetTimeOut);
    this.setState({ isClosed: true });
    ThermostatsActions.hideCompleteModal({ isClosed: true, text: this.props.text });
  };

  render() {
    const { text } = this.props;
    const { completeModalClose } = this;
    const { isClosed } = this.state;
    return <CompleteModal onClick={completeModalClose} isClosed={isClosed} text={text} />;
  }
}

export default connect(
  ({ thermostats }) => ({
    isClosed: thermostats.isCompleteModalClosed.isClosed,
    text: thermostats.isCompleteModalClosed.text
  }),
  () => ({})
)(CompleteModalContainer);



// WEBPACK FOOTER //
// ./src/app/thermostats/containers/CompleteModalContainer.js